import { combineReducers as reduxCombineReducers } from 'redux';
import { executeSecondaryReducersCombinations } from './utils';
import { executePersistConfigurations } from './execute';

/**
 * @param {object} reducers
 * @returns {function}
 * Función que devuelve diferentes comportamientos en función de como se ejecute la función retornada.
 */
export const combineReducers = (reducers) => {
  return (
    history,
    projectPersistConfigs,
    isRoot = false,
    executeFinalConfiguration = false,
  ) => {
    // Ejecución de las combinaciones de reducers que no esten el root.
    if (isRoot) executeSecondaryReducersCombinations(reducers);
    // Función que creara las configuraciones para la persistencia de datos.
    if (executeFinalConfiguration)
      return executePersistConfigurations(reducers, projectPersistConfigs);
    // Función que retorna la combinación de reducers secundarios para ser ejecutadas en el primer caso de esta función.
    if (!history && !projectPersistConfigs)
      return reduxCombineReducers(reducers);
    // Combinación del reducer root sin configuración de persistencia.
    if (!projectPersistConfigs) return reduxCombineReducers(reducers);
    // Combinación del reducer root con configuración de persistencia.
    return () => reduxCombineReducers(reducers);
  };
};
